import {gql} from 'apollo-angular';

export const GET_GAME_CATEGORIES_TEACHER = gql`
  query GetGameCategoriesTeacher($schoolClassId: Int!) {
    getGameCategoriesTeacher(schoolClassID: $schoolClassId) {
      id
      name
      isSelected
      isActive
      progress {
        id
        gameType
        roundNumber
        highscore
      }
    }
  }
`;
